/*tslint:disable-next-line:nx-enforce-module-boundaries*/
import { IConfigurations } from '@epicuro-next/platform/configuration';

export const PRODUCT_CARD_FEATURE_NAME = 'pcard';

export enum ProductCardConfigurationKeys {
  ProductTitleFormat = 'product-title-format',
  ProductTitlePrefixFormat = 'product-title-prefix-format',
  ProductIdFormat = 'product-id-format',
  ProductShowGender = 'product-show-gender-icon',
  ProductShowMainImageFullSpace = 'product-show-main-image-full-space',
  ProductShowCarouselNumber = 'product-show-carousel-number',
  ProductShowIconsOnHover = 'product-show-icons-on-hover',
  ProgressiveImageLoad = 'progressive-image-load',
  UseThumbnailsSkeleton = 'use-thumbnails-skeleton',
  PreviewProductAttributes = 'preview-product-attributes',
  HideMarkupPrice = 'hide-markup-price',
  ExtendedDabItems = 'extended-dab-items',
  ShowMarketingLabel = 'show-marketing-label',
  ShowWspdPrice = 'show-wspd-price',
  DateFormat = 'date-format',
  DeliveryDateVisibility = 'delivery-date-visibility',
  MultiRangeSliderInputs = 'multi-range-slider-inputs',
  ExpandButtonPeek = 'expand-button-peek',
}

export interface ProductCardConfiguration
  extends IConfigurations<ProductCardConfigurationKeys> {
  [ProductCardConfigurationKeys.ProductTitleFormat]: string[];
  [ProductCardConfigurationKeys.ProductTitlePrefixFormat]: string[];
  [ProductCardConfigurationKeys.ProductIdFormat]: string[];
  [ProductCardConfigurationKeys.ProductShowGender]: boolean;
  [ProductCardConfigurationKeys.ProductShowCarouselNumber]: boolean;
  [ProductCardConfigurationKeys.ProductShowIconsOnHover]: boolean;
  [ProductCardConfigurationKeys.ProgressiveImageLoad]: boolean;
  [ProductCardConfigurationKeys.UseThumbnailsSkeleton]: boolean;
  [ProductCardConfigurationKeys.PreviewProductAttributes]: boolean;
  [ProductCardConfigurationKeys.HideMarkupPrice]: boolean;
  [ProductCardConfigurationKeys.ExtendedDabItems]: boolean;
  [ProductCardConfigurationKeys.ShowMarketingLabel]: boolean;
  [ProductCardConfigurationKeys.ShowWspdPrice]: boolean;
  [ProductCardConfigurationKeys.DateFormat]: string;
  [ProductCardConfigurationKeys.DeliveryDateVisibility]: string | boolean;
  [ProductCardConfigurationKeys.ExpandButtonPeek]: boolean;
}

export const productCardConfigurationDefaults = {
  [ProductCardConfigurationKeys.HideMarkupPrice]: false,
  [ProductCardConfigurationKeys.ShowWspdPrice]: false,
  [ProductCardConfigurationKeys.ProductIdFormat]: ['displayedProductId'], // brooks parentId, colorCode
  [ProductCardConfigurationKeys.ProductTitleFormat]: ['articleTitle'],
  [ProductCardConfigurationKeys.ExpandButtonPeek]: false,
};
